<template>
  <a href="#" class="navbar-nav-link align-items-center rounded-pill p-1" data-bs-toggle="dropdown"
    :class="{ 'disabled': !totalNotifications }">
    <div class="status-indicator-container">
      <i class="ph-envelope-simple fs-1"></i>
      <span class="badge text-white position-absolute top-0 start-100 translate-middle rounded-pill" :style="{
        fontSize: '0.7rem',
        backgroundColor: totalNotifications ? '#dc3545' : '#6c757d'// kırmızı ya da gri
      }">
        {{ totalNotifications }}
      </span>

    </div>
  </a>


  <div class="dropdown-menu dropdown-menu-end">
    <router-link v-if="prCount" to="/approval-purchase-request?approvalStatus=WaitingApproval"
      class="dropdown-item d-flex align-items-center justify-content-between" aria-disabled="true">
      <div>
        <i class="me-2 text-warning ph-clock border border-3 rounded-circle p-1 border-warning"></i>
        <span v-html="$t('Notification_PurchaseRequest_0', [prCount])"></span>
      </div>
    </router-link>

    <div v-if="poCount && prCount" class="dropdown-divider"></div>

    <router-link v-if="poCount" to="/approval-purchase-order?approvalStatus=WaitingApproval"
      class="dropdown-item d-flex align-items-center justify-content-between" aria-disabled="true">
      <div>
        <i class="me-2 text-warning ph-clock border border-3 rounded-circle p-1 border-warning"></i>
        <span v-html="$t('Notification_PurchaseOrder_0', [poCount])"></span>
      </div>
    </router-link>
  </div>


</template>
<script>
import { ResponseCode } from '@/CommonVueCore/src/constants/globalEnums/ResponseCode';
import { useAuthAppStore } from '@/store/stores/authStore';


export default {
  inject: ['cproxServiceClient', 'purchaseOrderService', 'purchaseRequestService'],
  data() {
    return {
      useAuthAppStore: useAuthAppStore(),
      totalNotifications: 0,
      prCount: 0,
      poCount: 0,
      // Interval ID'sini tutmak için değişken eklendi
      notificationInterval: null 
    }
  },
  methods: {
    // API isteklerini ayrı bir asenkron metoda taşıdık
    async fetchNotifications() {
      // API çağrılarının aynı anda yapılmasını sağladık
      const [prResponse, poResponse] = await Promise.all([
        this.purchaseRequestService.getStatsByApprover({ purchaseRequestServiceClient: this.cproxServiceClient.pRequest }),
        this.purchaseOrderService.getStatsByApprover({ purchaseOrderServiceClient: this.cproxServiceClient.pOrder })
      ]);

      let total = 0;
      if (prResponse?.data?.ResponseCode === ResponseCode.SUCCESS) {
        total += prResponse?.data?.Data ?? 0;
        this.prCount = prResponse?.data?.Data ?? 0;
      }
      if (poResponse?.data?.ResponseCode === ResponseCode.SUCCESS) {
        total += poResponse?.data?.Data ?? 0;
        this.poCount = poResponse?.data?.Data ?? 0;
      }
      this.totalNotifications = total;
    }
  },
  // Bileşen DOM'a eklendiğinde çalışır (created'dan sonra ve DOM hazır olduğunda)
  mounted() {
    // 1. İlk yüklemeyi hemen yap
    this.fetchNotifications(); 

    // 2. 30 saniyede bir tekrarla (30000 milisaniye)
    this.notificationInterval = setInterval(this.fetchNotifications, 30000); 
    console.log("Bildirim yenileme intervali başlatıldı.");
  },
  // Bileşen DOM'dan kaldırılmadan hemen önce çalışır (Vue 2 karşılığı)
  beforeUnmount() {
    // Hafıza sızıntısını önlemek için interval'i temizle
    if (this.notificationInterval) {
      clearInterval(this.notificationInterval);
      console.log("Bildirim yenileme intervali temizlendi.");
    }
  }
}
</script>
<style></style>